import { Icon } from '../../../../common/html/icon'
import { Tooltip } from '../../../../common/tooltip'

export const BookmarkCell = ({ val, rowId, onClickBookmark }) => {
  return (
    <div onClick={(e) => onClickBookmark(e, rowId, val)}>
      <Tooltip
        isI18n={true}
        tooltipContent={
          val ? 'newsAndSocial.REMOVE_BOOKMARK' : 'newsAndSocial.ADD_BOOKMARK'
        }
        tooltipContentStyle={{ fontSize: 10 }}
      >
        {val ? (
          <Icon
            style={{ color: '#E8B714', fontSize: 16 }}
            className={'icon-bookmark-fill'}
          />
        ) : (
          <Icon
            style={{ color: '#9c9c9c', fontSize: 16 }}
            className={'icon-bookmark-outline'}
          />
        )}
      </Tooltip>
    </div>
  )
}
